<script lang="ts" setup>
    import {computed} from "vue";

    import DDivider from "../atoms/DDivider.vue";
    import DContainer from "../atoms/DContainer.vue";
    import DText from "../atoms/DText.vue";
    import DIcon from "../atoms/DIcon.vue";

    import DReviewUserAvatar from "../molecules/DReviewUserAvatar.vue";

    import type {BaseCardType, NormalizedAsset} from "@songfinch/types"; 

    const props = defineProps<
        BaseCardType & {
            reviewText?: string;
            avatar?: {
                image?: NormalizedAsset;
                name?: string;
                meta?: string;
            };
        }
    >();

    const cardTheme = computed(() => {
        return props.theme === "light" ? "white" : "light";
    });
</script>

<template>
    <DContainer
        class="d-review-card"
        :data-test-td="dataTestId"
        display="grid"
        variant="card"
        :theme="cardTheme"
    >
        <DContainer class="d-review-card-stars">
            <DIcon v-for="i in 5" :key="i" name="star"/>
        </DContainer>

        <DText
            class="d-review-card-review-text"
            variant="p-3"
        >
            "{{reviewText}}"
        </DText>
        <DDivider spacing="tight" :theme="theme"/>
        <DReviewUserAvatar v-if="avatar" class="d-review-avatar" :avatar="avatar"/>
    </DContainer>
</template>

<style lang="scss" scoped>
.d-review-card {
  padding-bottom: 1rem;
  border-radius: var(--radius-16);
  width: 270px;
  height: 352px;
}

.d-review-card-stars {
  font-size: 1.25rem;
  margin-bottom: var(--size-20);
}

.d-review-card-review-text {
  height: 180px;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 8; /* number of lines to show */
  line-clamp: 8;
}

.d-review-avatar {
  align-self: flex-end;
}
</style>
